import { Pagination, Select } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Icon } from "@iconify/react/dist/iconify.js";
import { getDoctorSpecialities, getNearByDoctors } from "../../api/Doctor";
import { useDispatch, useSelector } from "react-redux";
import { dispatchConst } from "../../RTK/type";
import { middleware } from "../../RTK/middleware";
import DoctorCard from "../Components/DoctorCard";
import Map from "../Components/MapComponent";
import { useNavigate } from "react-router-dom";

const YourDoctors = () => {
  // const [doctorSpecialities, setDoctorSpecialities] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [speciality, setSpeciality] = useState(0);
  const [address, setAddress] = useState("");
  const [userLocation, setUserLocation] = useState({});
  const [paginationCount, setPaginationCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const navigate = useNavigate();

  const [doctorList, setDoctorList] = useState([]);
  // const [latLng, setLatLng] = useState();
  const doctorSpecialities = useSelector(({ main }) => main.specialities);

  const dispatch = useDispatch();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let address = urlParams.get("address");
    let latLong = urlParams.get("latLong")?.split(",");
    console.log("address::::", latLong, address, );
    console.log("usrldataLLL:::", urlParams.get("speciality"));

    if(urlParams.get("speciality")){
      setSpeciality(Number(atob(urlParams.get("speciality"))));
      console.log("usrldataLLL1:::", urlParams.get("speciality"));
    }
    
    if (address && latLong) {
      address = atob(urlParams.get("address"));
      latLong = atob(urlParams.get("latLong")).split(",");
      setAddress(address);
      console.log("doctorSpecialities::", doctorSpecialities.length > 0);
      if (doctorSpecialities.length === 0) {
        getSpeciality();
      }

      try {
        let obj = {
          latitude: parseFloat(latLong[0]),
          longitude: parseFloat(latLong[1]),
          // pageNo: currentPage,
        };
        setUserLocation(obj);
      } catch (error) {
        console.log("error", error);
        navigate("/home");
      }
      // getDoctors(obj);
    } else {
      navigate("/home");
    }
  }, []);

  useEffect(() => {
    // console.log("userLocation.length::", Object.keys(userLocation).length);
    if (Object.keys(userLocation).length > 0 && userLocation) {
      let obj = {
        ...userLocation,
        pageNo: currentPage,
        specialityId: speciality,
      };
      // console.log("speciality:::", speciality);

      getDoctors(obj);
    }
  }, [userLocation, speciality, currentPage]);

  const onChange = (value) => {
    console.log(`selected ${value}`, doctorList);
    console.log(typeof value);
    setSpeciality(value);
    setCurrentPage(0);
  };

  const getSpeciality = () => {
    setLoader(true);
    getDoctorSpecialities({})
      .then((response) => {
        if (response.data.status === 1) {
          dispatch(
            middleware({
              data: response.data.data,
              dispatchType: dispatchConst.specialities,
            })
          );
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const getDoctors = (latLng) => {
    setLoader(true);

    // const latitude = latLng.split(",")[0];
    // const longitude = latLng.split(",")[1];

    getNearByDoctors(latLng)
      .then((response) => {
        if (response.data.status === 1) {
          // setDoctorList(response.data.data);
          setDoctorList(response.data.data);
          setPaginationCount(response.data?.data[0]?.totalRecords);
          setLoader(false);
        } else if (response.data.status === 0) {
          setDoctorList([]);
          setPaginationCount(0);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const onPageChange = (newCurrent) => {
    setCurrentPage(newCurrent - 1);
  };

  return (
    <Container>
      <Row className="unitedbgColor px-5 py-4">
        <span className="ps-5 ms-3">{paginationCount} Results for</span>
        <Col className="d-flex align-items-center">
          <Icon
            icon="famicons:arrow-back-circle"
            width="40"
            height="40"
            className="me-3 cursor-pointer"
            style={{ color: "#9ED0E7" }}
            onClick={() => navigate("/home")}
          />
          <h2 className="textWhite font-family-Mar">{address}</h2>
        </Col>
      </Row>
      <Row className="bgWhite">
        <Col className="mx-md-5 px-md-5">
          <div className="d-flex justify-content-between align-items-center py-2">
            <div>
              <Select
                placeholder="Speciality"
                size="small"
                value={speciality}
                showSearch
                onChange={onChange}
                // onSearch={onSearch}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                className="yourDoctor-filter"
                options={[{ label: "All", value: 0 }, ...doctorSpecialities]}
                dropdownStyle={{ minWidth: "300px" }}
                style={{ minWidth: 150 }} // Optional: Set minimum width
              />
            </div>
            <div className="chip-background">
              <span className="chip" onClick={() => setShowMap(!showMap)}>
                <Icon
                  icon="material-symbols:map-outline"
                  style={{ color: "#000" }}
                />
                {showMap ? "Hide Map" : "Show Map"}
              </span>
            </div>
          </div>
        </Col>
        <hr className="mb-4" />
      </Row>
      <Row>
        {showMap ? (
          <>
            {/* 50% Doctors List */}
            <Col
              md={6}
              className="screen-50"
              style={{ overflowY: "auto", maxHeight: "70vh" }}
            >
              {loader ? (
                <p>Loading providers...</p>
              ) : (
                doctorList
                  // .filter(
                  //   (doctor) =>
                  //     speciality === doctor.specialityId || speciality === 0
                  // )
                  .map((doctor, index) => (
                    <DoctorCard key={index} doctor={doctor} />
                  ))
              )}
            </Col>

            {/* 50% Map View */}
            {doctorList.length !== 0 && (
              <Col md={6} style={{ height: "70vh" }}>
                <Map userLocation={userLocation} doctors={doctorList} />
              </Col>
            )}
          </>
        ) : (
          <Col md={12}>
            {/* 100% Doctors List */}
            {loader ? (
              <p>Loading providers...</p>
            ) : (
              doctorList
                .filter(
                  (doctor) =>
                    speciality === doctor.specialityId || speciality === 0
                )
                .map((doctor, index) => (
                  <DoctorCard key={index} doctor={doctor} />
                ))
            )}
          </Col>
        )}
        <Col>
          {paginationCount > 10 && (
            <Pagination
              current={currentPage + 1}
              defaultCurrent={1}
              total={paginationCount}
              defaultPageSize={10}
              onChange={onPageChange}
              showSizeChanger={false}
            />
          )}
        </Col>
        {doctorList.length === 0 && (
          <Col className="p-5" xs="12" align="center">
            <p>No doctor available</p>
            {speciality === 0 && (
              <Button className="uniteButton" onClick={() => navigate("/home")}>
                <Icon
                  icon="eva:arrow-ios-back-outline"
                  className="me-3"
                  width="24"
                  height="24"
                />{" "}
                Go back and try different location
              </Button>
            )}
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default YourDoctors;
